import moment from 'moment'

const defaultFormats = {
    ru: {
        shortDate: 'DD.MM.YYYY',
        fullDate: 'D MMMM YYYY [г.]',
        fullMonth: 'D MMMM',
        time: 'HH:mm',
        datetime: 'DD.MM.YYYY HH:mm',
        decimal: ',',
        thousand: ' ',
        percent: '%',
    },
    eu: {
        shortDate: 'DD/MM/YYYY',
        fullDate: 'D MMMM YYYY',
        fullMonth: 'D MMMM',
        time: 'HH:mm',
        datetime: 'DD/MM/YYYY HH:mm',
        decimal: '.',
        thousand: ',',
        percent: '%',
    },
    na: {
        shortDate: 'MM/DD/YYYY',
        fullDate: 'MMMM D, YYYY',
        fullMonth: 'MMMM D',
        time: 'h:mm a',
        datetime: 'MM/DD/YYYY h:mm a',
        decimal: '.',
        thousand: ',',
        percent: '%',
    },
    asia: {
        shortDate: 'MM/DD/YYYY',
        fullDate: 'MMMM D, YYYY',
        fullMonth: 'MMMM D',
        time: 'h:mm a',
        datetime: 'MM/DD/YYYY h:mm a',
        decimal: '.',
        thousand: ',',
        percent: '%',
    },
    kr: {
        shortDate: 'MM/DD/YYYY',
        fullDate: 'MMMM D, YYYY',
        fullMonth: 'MMMM D',
        time: 'h:mm a',
        datetime: 'MM/DD/YYYY h:mm a',
        decimal: '.',
        thousand: ',',
        percent: '%',
    },
    cn360: {
        shortDate: 'YYYY-MM-DD ',
        fullDate: 'YYYY[年]M[月]D[日]',
        fullMonth: 'M[月]D[日]',
        time: 'H:mm',
        datetime: 'YYYY-MM-DD H:mm',
        decimal: '.',
        thousand: ',',
        percent: '%',
    },
}

const formatsByRealms = {
    ct: {
        ru: defaultFormats.ru,
        en: defaultFormats.eu,
    },
    ru: {
        ru: defaultFormats.ru,
        en: defaultFormats.eu,
        be: {
            ...defaultFormats.ru,
        },
        kk: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D MMMM, YYYY',
            fullMonth: 'D MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        uk: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D MMMM YYYY [р.]',
            fullMonth: 'D MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
    },
    eu: {
        ru: defaultFormats.ru,
        kk: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D MMMM, YYYY',
            fullMonth: 'D MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        uk: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D MMMM YYYY [р.]',
            fullMonth: 'D MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        en: defaultFormats.eu,
        bg: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        cs: {
            shortDate: 'D.M. YYYY',
            fullDate: 'D. MMMM YYYY',
            fullMonth: 'D. MMMM',
            time: 'HH:mm',
            datetime: 'D.M. YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        da: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        de: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D. MMMM YYYY',
            fullMonth: 'D. MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        el: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        es: {
            shortDate: 'D/M/YYYY',
            fullDate: 'D [de] MMMM [de] YYYY',
            fullMonth: 'D [de] MMMM',
            time: 'H:mm',
            datetime: 'D/M/YYYY H:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        et: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'D. MMMM YYYY',
            fullMonth: 'D. MMMM',
            time: 'H:mm',
            datetime: 'DD.MM.YYYY H:mm',
            decimal: ',',
            thousand: ' ',
            percent: '%',
        },
        fi: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        fr: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'H [h] mm',
            datetime: 'DD/MM/YYYY H [h] mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        hr: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        hu: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        it: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: ',',
            thousand: '.',
            percent: '%',
        },
        lt: {
            shortDate: 'YYYY-MM-DD',
            fullDate: 'YYYY [m.] MMMM D [d.]',
            fullMonth: 'MMMM D',
            time: 'HH:mm',
            datetime: 'YYYY-MM-DD HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        lv: {
            shortDate: 'DD.MM.YYYY',
            fullDate: 'YYYY. [gada] D. MMMM',
            fullMonth: 'D. MMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: '%',
        },
        nl: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        no: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        pl: {
            shortDate: 'D.MM.YYYY',
            fullDate: 'D MMMM, YYYY',
            fullMonth: 'D MMMM',
            time: 'HH:mm',
            datetime: 'D.MM.YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: '%',
        },
        pt: {
            shortDate: 'DD/MM/YYYY',
            fullDate: 'D [de] MMMM [de] YYYY',
            fullMonth: 'D [de] MMMM',
            time: 'H:mm',
            datetime: 'DD/MM/YYYY H:mm',
            decimal: ',',
            thousand: ' ',
            percent: '%',
        },
        ro: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        sr: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        sv: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        tr: {
            shortDate: 'DD/MM/YYYY',
            fullDate: defaultFormats.eu.fullDate,
            fullMonth: defaultFormats.eu.fullMonth,
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: ',',
            thousand: '.',
            percent: '%',
            percentBefore: true,
        },
    },
    na: {
        'en': defaultFormats.na,
        'fr': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.na.fullDate,
            fullMonth: defaultFormats.na.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'es-ar': {
            shortDate: 'DD/MM/YYYY',
            fullDate: 'D [de] MMMM [de] YYYY',
            fullMonth: 'D [de] MMMM',
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: ',',
            thousand: ' ',
            percent: ' %',
        },
        'es-mx': {
            shortDate: 'DD/MM/YYYY',
            fullDate: 'D [de] MMMM [del] YYYY',
            fullMonth: 'D [de] MMMM',
            time: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
            decimal: '.',
            thousand: ' ',
            percent: ' %',
        },
        'pt-br': {
            shortDate: 'DD/MM/YYYY',
            fullDate: 'D [de] MMMM [de] YYYY',
            fullMonth: 'D [de] MMMM',
            time: 'H:mm',
            datetime: 'DD/MM/YYYY H:mm',
            decimal: ',',
            thousand: '.',
            percent: '%',
        },
        'ja': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.na.fullDate,
            fullMonth: defaultFormats.na.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'ko': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.na.fullDate,
            fullMonth: defaultFormats.na.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
    },
    asia: {
        'en': defaultFormats.asia,
        'ja': {
            shortDate: 'YYYY/MM/DD',
            fullDate: 'YYYY[年]MM[月]DD[日]',
            fullMonth: 'MM[月]DD[日]',
            time: 'HH:mm',
            datetime: 'YYYY/MM/DD HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'vi': {
            shortDate: 'DD/MM/YYYY',
            fullDate: '[ngày] D [tháng] M [năm] YYYY',
            fullMonth: '[ngày] D [tháng] M',
            time: 'HH:mm',
            datetime: 'DD/MM/YYYY HH:mm',
            decimal: '.',
            thousand: ' ',
            percent: '%',
        },
        'fil': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.asia.fullDate,
            fullMonth: defaultFormats.asia.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'ms': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.asia.fullDate,
            fullMonth: defaultFormats.asia.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'id': {
            shortDate: 'MM/DD/YYYY',
            fullDate: defaultFormats.asia.fullDate,
            fullMonth: defaultFormats.asia.fullMonth,
            time: 'h:mm a',
            datetime: 'MM/DD/YYYY h:mm a',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'th': {
            shortDate: 'D.M.YYYY',
            fullDate: 'D MMMM YYYY',
            fullMonth: 'D MMMM',
            time: 'H:mm',
            datetime: 'D.M.YYYY H:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'ko': {
            shortDate: 'YYYY/M/D',
            fullDate: 'YYYY[년] M[월] D[일]',
            fullMonth: 'M[월] D[일]',
            time: 'HH:mm',
            datetime: 'YYYY/M/D HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'zh-cn': {
            shortDate: 'YYYY-MM-DD',
            fullDate: 'YYYY[年]M[月]D[日]',
            fullMonth: 'M[月]D[日]',
            time: 'H:mm',
            datetime: 'YYYY-MM-DD H:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
        'zh-sg': {
            shortDate: 'YYYY/MM/DD',
            fullDate: 'YYYY[年]M[月]D[日]',
            fullMonth: 'M[月]D[日]',
            time: 'HH:mm',
            datetime: 'YYYY/MM/DD HH:mm',
            decimal: '.',
            thousand: '',
            percent: '%',
        },
        'zh-tw': {
            shortDate: 'YYYY/MM/DD',
            fullDate: 'YYYY [年] MM [月] DD [日]',
            fullMonth: 'M [月] D [日]',
            time: 'HH:mm',
            datetime: 'YYYY/MM/DD HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
    },
    kr: {
        en: defaultFormats.kr,
        ko: {
            shortDate: 'YYYY/M/D',
            fullDate: 'YYYY[년] M[월] D[일]',
            fullMonth: 'M[월] D[일]',
            time: 'HH:mm',
            datetime: 'YYYY/M/D HH:mm',
            decimal: '.',
            thousand: ',',
            percent: '%',
        },
    },
    cn360: {
        'zh-cn': defaultFormats.cn360,
    },
}

export class FormatsManager {
    static currentLang = null
    static currentRealm = null
    static currentFormats = null
    static initializeFormats(realm, lang, localeSpecification = {}) {
        FormatsManager.realm = realm.toLowerCase()
        FormatsManager.lang = lang.toLowerCase()
        FormatsManager.currentFormats = FormatsManager.getFormatsForLanguage(
            FormatsManager.realm,
            FormatsManager.lang,
        )
        moment.updateLocale(FormatsManager.lang, localeSpecification)
    }

    static getFormats() {
        return FormatsManager.currentFormats
    }

    static getFormatsForLanguage = (realm = '', lang = '') => {
        realm = realm.toLowerCase(), lang = lang.toLowerCase()
        if (formatsByRealms[realm]) {
            return formatsByRealms[realm][lang] || defaultFormats[realm]
        }
        return defaultFormats.eu
    }
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/helpers/formatting.js